import { SPOT_LAYOUTS, DATES } from "./config";

// Positions for one day, matching the beach service's chart: a
// three-sided box opening toward the water on the left. Numbering runs
// left-to-right along the top row, down the right column, then back
// along the bottom — so the bottom row is rendered highest-number-first
// and its last tile sits beside the bottom of the right column.
export const buildSpotLayout = (date) => {
  const spec = SPOT_LAYOUTS[date] || SPOT_LAYOUTS[DATES[0]];
  const { top: topCount, right: rightCount, bottom: bottomCount } = spec;
  const total = topCount + rightCount + bottomCount;
  return {
    top: Array.from({ length: topCount }, (_, i) => i + 1),
    right: Array.from({ length: rightCount }, (_, i) => topCount + i + 1),
    bottom: Array.from({ length: bottomCount }, (_, i) => total - i),
    total,
    confirmed: Boolean(spec.confirmed),
  };
};

// Short label for a spot tile: initials of the guest actually sitting
// there (the alias when set, otherwise the person who booked it).
export const spotInitials = (assignment) => {
  const name = assignment?.alias || assignment?.bookedBy;
  if (!name) return "";
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");
};

// Rearranging: dropping a set on another spot inserts it there and
// shifts everything in between one place over to make room, the way you
// would slide chairs down a row. Nobody is displaced — the spot the set
// came from is what absorbs the shift. Returns only the spots that
// change, mapped to their new occupant (or null when they empty out).
export const planInsertShift = (dayAssignments = {}, from, to) => {
  const source = dayAssignments?.[from];
  if (!source?.key || from === to) return {};

  const step = to > from ? 1 : -1;
  const plan = {};
  for (let spot = from; spot !== to; spot += step) {
    plan[spot] = dayAssignments[spot + step] || null;
  }
  plan[to] = source;
  return plan;
};

// One row per spot that has someone's name on it, in spot order. Spots
// that only carry a leftover alias are included and flagged, so a report
// never silently drops a label.
export const buildSpotRows = (dayAssignments) =>
  Object.entries(dayAssignments || {})
    .filter(([, assignment]) => assignment?.key || assignment?.alias)
    .map(([spot, assignment]) => ({
      spot: Number(spot),
      key: assignment.key || "",
      guest: assignment.alias || assignment.bookedBy || "",
      bookedBy: assignment.bookedBy || "",
      assigned: Boolean(assignment.key),
    }))
    .sort((a, b) => a.spot - b.spot);

// "Laura Smith (booked by Ryan Kennedy)" — full description of who a
// spot belongs to.
export const describeAssignment = (assignment) => {
  if (!assignment) return "";
  const { alias, bookedBy } = assignment;
  if (alias && bookedBy) return `${alias} (booked by ${bookedBy})`;
  return alias || bookedBy || "";
};
